<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-10-14 11:47:42
 * @LastEditTime: 2019-10-14 11:47:42
 * @LastEditors: your name
 -->
<template>
  <div>
    <template v-for="(column) in list">
      <el-table-column
        v-if="column.prop && column.show !== false"
        :key="column.prop"
        :prop="column.prop"
        :label="$lang(column.label)"
        filter-placement="bottom-end"
        :show-overflow-tooltip="column.overHidden || true"
        :filter-method="column.filter? handleFiltersMethod : undefined"
        :filter-multiple="column.filterMultiple"
        :min-width="column.minWidth"
        :sortable="column.sortable"
        :render-header="column.renderHeader"
        :align="column.align"
        :header-align="column.headerAlign"
        :width="column.width"
        :fixed="$parent.isMobile ? false : column.fixed">
        <template slot-scope="scope">
          <slot v-if="column.slot"
                :row="scope.row"
                :dic="crud.DIC[column.prop]"
                :name="column.prop"
          ></slot>
          <render v-else-if="column.render" :renderFormat="column.render" :row="scope.row" :valueKey="column.prop" />
          <template v-else>
            <span v-html="handleDetail(scope.row,column)"></span>
          </template>
        </template>
      </el-table-column>
    </template>
  </div>
</template>

<script>
import find from 'lodash/find'
import render from './render.js'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'jmscolumn',
  components: {
    render
  },
  props: {
    columnOption: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  inject: ['crud'],
  computed: {
    list() {
      const result = [...this.columnOption].filter((item) => {
        return item.show !== false
      })
      return result
    },
  },
  methods: {
    handleDetail(row, column) {
      // 自定义的格式化函数
      if (typeof column.formatter === 'function') {
        return column.formatter(row) || '--'
      }
      // // 字典转文字
      if (column.type === 'select' && this.crud.DIC[column.prop] && typeof row[column.prop] === 'number') {
        const data = find(
          this.crud.DIC[column.prop],
          // eslint-disable-next-line
          (item) => item[column.props ? column.props.value : 'value'] == row[column.prop]
        )
        return data ? data[column.props ? column.props.label : 'label'] : '--'
      }
      // 直接返回值
      return row[column.prop] || '--'
    },
    // 表格筛选逻辑
    handleFiltersMethod(value, row, column) {
      const columnNew = this.columnOption.filter(ele => ele.prop === column.property)[0]
      if (typeof columnNew.filtersMethod === 'function') {
        return columnNew.filtersMethod(value, row, columnNew)
      } else {
        return row[columnNew.prop] === value
      }
    },
  },
}
</script>

